import { z } from 'zod';
import { WorkflowSchema } from './recipes.js';
export const VALIDATION_CODES = [
    'unknown_node', 'missing_input', 'link_target_missing', 'link_output_missing', 'link_type_mismatch', 'expected_link',
    'wrong_type', 'out_of_range', 'not_an_option', 'cycle', 'no_output', 'unknown_input', 'no_save',
];
export const ValidationCodeSchema = z.enum(VALIDATION_CODES);
/** One problem, keyed by node id and input; nodeId is null for whole-graph problems. */
export const ValidationIssueSchema = z.object({
    nodeId: z.string().nullable(),
    classType: z.string().optional(),
    input: z.string().optional(),
    code: ValidationCodeSchema,
    message: z.string(),
});
export const ValidationResultSchema = z.object({
    valid: z.boolean(),
    errors: z.array(ValidationIssueSchema),
    warnings: z.array(ValidationIssueSchema),
});
export const ValidateWorkflowRequestSchema = z.object({ machineId: z.string().min(1).max(64), workflow: WorkflowSchema });
export const ValidateRecipeRequestSchema = z.object({
    machineId: z.string().min(1).max(64).optional(),
    version: z.number().int().min(1).optional(),
});
//# sourceMappingURL=validation.js.map